<template>
  <base-dialog
    :title="'room.param.doors.title' | i18n"
    :subtitle="'room.param.doors.subtitle' | i18n"
    :description="'room.param.doors.description' | i18n">


    <div class="container-fluid" style="padding: 0;">
      <div class="row">
        <div class="col-4">
          <img src="../../assets/param/room_doors.png" />
        </div>

        <div class="col-8">
          <label>Väliovien määrä kpl</label>
          <select v-model="numOfDoors" class="form-control">
            <option v-for="n in 6" :value="n-1">{{ n-1 }}</option>
          </select>
        </div>
      </div>
    </div>
  </base-dialog>
</template>


<script>
  import BaseDialog from "./BaseDialog"

  export default {
    computed: {
      numOfDoors: {
        get() {
          return this.$store.state.roomParams.numOfDoors
        },
        set(numOfDoors) {
          this.$store.commit('roomParams/SET_NUM_OF_DOORS', numOfDoors)
        }
      }
    },

    created() {
      if(this.numOfDoors == null) {
        this.numOfDoors = 0
      }
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  img {
    max-width: 100%;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/RoomDoorsDialog.vue